







import Vue from 'vue'
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn } from '@/components/apiSearch/models/ApiSearch';
import { t } from "@/plugins/i18n";

export default Vue.extend({
    components: {
        ApiSearchPage
    },

    computed: {
        url() {
      return `cashPoint/open-payoff-downpayments`;
    },

    columns: (): ApiSearchColumn[] => [
      { field: "name", title: t("Penztar") },
      { field: "employee", title: t("Munkavallalo") },
      { field: "statement", title: t("Kivonat") },
      { field: "document", title: t("BizonylatSorszam") },
      { field: "docItem", title: t("CashPoint_BizonylatTetel") },
      { field: "amount", title: t("CashPoint_BizonylatTetelOsszege") },
      { field: "amount", cell: "select", title: "", fieldClass: "text-center", filterable: false, sortable: false},
    ]
    }
})
